const eagerFetchImage = async (url) => {
  if (!url) {
    return url;
  }

  const response = await fetch(url);
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};

export default eagerFetchImage;
